var render = function (_h,_vm) {var _c=_vm._c;return _vm._m(0)}
var staticRenderFns = [function (_h,_vm) {var _c=_vm._c;return _c('main',{staticClass:"al-error-not-found"},[_c('h1',[_vm._v("404")]),_c('p',[_vm._v("What were you looking for?")])])}]

export { render, staticRenderFns }